// extracted by mini-css-extract-plugin
module.exports = {"header":"capcalera_header__qQRT4","headerText":"capcalera_headerText__NEn0e","subheader":"capcalera_subheader__3_8dS"};